<template>
  <div class="bouton">
    <v-btn
      :rounded="btnForm"
      @click="click"
      :elevation="elevation"
      class="button"
      :class="{
        'purple-verion': btnType === 'order',
        'orange-version': btnType === 'install',
        'primary-version': btnType === 'connexion',
        'blueLight-version': btnType === 'cancel',
        'white-version theme-btn with-border': btnType === 'sendMail',
        'pink-lowercase-version ': btnType === 'initialize',
        'orange-dark-version ': btnType === 'compare',
        bigHeight: hasBigHeight,
        'green-version': status === 'En ligne',
        'orange-no-shadow-version': status === 'En mise à jour',
        'grey-version': status === 'Hors ligne',
        isDisabled: isDisabled,
        'purple-empty-version': btnType === 'overview',
        'orange-alt-version': btnType === 'edit',
        'purple-light-version': btnType === 'save',
      }"
    >
      <span
        :class="{
          'text-grey-color': labelColor === 'grey',
          'white-label': !labelColor,
          'pink-label ': labelColor === 'pink',
          'purple-dark-label': labelColor === 'purple-dark',
        }"
      >
        {{ label }}
      </span>
      <v-icon
        v-if="icon !== ''"
        class="material-icons-outlined pa-1"
        :color="iconColor"
      >
        {{ icon }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script type="text/javascript">
import TextInput from "@/components/input/textInput.vue";
import customButton from "@/components/buttons/customButton.vue";

export default {
  components: {
    TextInput,
    customButton,
  },
  name: "customButton",
  props: {
    label: {
      type: String,
      default: "",
    },
    labelColor: {
      type: String,
      default: "",
    },
    btnType: {
      type: String,
      default: "",
    },
    btnForm: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
    iconColor: {
      type: String,
      default: "",
    },
    status: {
      type: String,
      default: "",
    },
    hasBigHeight: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    elevation: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    click() {
      this.$emit("click", this.label);
    },
  },
};
</script>


<style lang="scss">
.bouton {
  padding: none !important;
  background-color: $pure-white !important;
  .isDisabled {
    pointer-events: none !important;
    opacity: 0.3;
  }
  .card-btn {
    padding-bottom: 13.5em;
  }
  .purple-dark-label {
    color: $color-secondary;
  }
  .white-label {
    color: $pure-white;
  }
  .orange-version {
    background-color: $color-primary !important;
  }
  .blueLight-version {
    background-color: $blue-light-button !important;
    border: 2px solid $blue-light-border !important;
  }
  .primary-version {
    background-color: $color-primary !important;
    border-radius: 0px !important;
  }
  .orange-dark-version {
    background-color: $color-primary !important;
    border: 1px solid $blue-light-border !important;
    box-shadow: none !important;
  }
  .bigHeight {
    height: 54px !important;
  }
  .green-version {
    background-color: $green-button !important;
    text-transform: none !important;
  }
  .orange-no-shadow-version {
    background-color: $color-primary !important;
    text-transform: none !important;
  }
  .grey-version {
    background-color: $grey-button !important;
    text-transform: none !important;
  }
  .pink-lowercase-version {
    background-color: $pink-base !important;
    text-transform: none !important;
    border-radius: 0px !important;
  }
  .white-version {
    background-color: $pure-white !important;
    text-transform: none !important;
    border-radius: 0px !important;
  }
  .button {
    width: 100%;
  }
  .purple-empty-version {
    background-color: white !important;
    text-transform: to-upper-case($string: "");
    border: 1px solid $color-secondary !important;
  }
  .orange-alt-version {
    background-color: $color-primary !important;
  }
  .purple-light-version {
    background-color: $icon-purple !important;
  }
}
</style>